import React from 'react'
import { useState } from 'react'
import UserModal from '../components/Modal'

import img_1 from "../assets/img_1.png"
import img_2 from "../assets/img_2.png"
import img_3 from "../assets/img_3.png"
import img_4 from "../assets/img_4.png"

import check from "../assets/check.png"
import delet from "../assets/delete.png"

function Energy() {

    const [modalItem, setModalItem] = useState("");
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = (modalItemValue) => { setShow(true); setModalItem(modalItemValue) };


    return (
        <>
            <section className='energy_sec'>
                <div className="container">
                    <div className='d-flex jc-between ai-center'>
                        <h3>Total Energy Available: <span style={{ fontSize: "28px", fontWeight: "bolder", color: "#8f43ed" }}>100kwh</span></h3>
                        <div className=''>
                            <UserModal btnText="Update Energy" id="Update Energy" customClasses="energy_btn me-3" modalItem={modalItem} show={show} handleClose={handleClose} handleShow={handleShow}>
                                <div>
                                    <h3 className='text-center mb-4'>Price per kwh</h3>
                                    <div className='d-flex jc-between ai-center'>
                                        <div className='mb-4'>
                                            <label for="customRange1" className="form-label">Set your price range</label>
                                            <input type="range" className="form-range" id="customRange1"></input>
                                        </div>
                                        <div className='value'>
                                            <p>$ 250</p>
                                        </div>
                                    </div>
                                    <button className='btn confirm_btn'>Confirm</button>
                                </div>
                            </UserModal>
                            {/* <button className='btn energy_btn me-3'>Update Energy</button> */}
                            <button className='btn energy_btn'>Stop Energy</button>
                        </div>
                    </div>
                    <div className='table-responsive'>
                        <table className="table table-striped mt-5 text-center">
                            <thead>
                                <tr>
                                    <th scope="col">Name</th>
                                    <th scope="col">Transaction status</th>
                                    <th scope="col">Transaction type</th>
                                    <th scope="col">Auto purchase</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Price/kwh</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">
                                        <div className='d-flex ai-center'>
                                            <img src={img_1} alt="image" className='img-fluid me-2' />
                                            Abraham98
                                        </div>
                                    </th>
                                    <td><small className='success'>Success</small></td>
                                    <td>Purchase</td>
                                    <td>
                                        <img src={check} alt="image" className='img-fluid' />
                                    </td>
                                    <td>5</td>
                                    <td>
                                        <span>2 Matic per kwh</span> <br />
                                        <small>(2.5 USD)</small>
                                    </td>
                                </tr>

                                <tr>
                                    <th scope="row">
                                        <div className='d-flex ai-center'>
                                            <img src={img_2} alt="image" className='img-fluid me-2' />
                                            lever_jk8
                                        </div>
                                    </th>
                                    <td><small className='success'>Success</small></td>
                                    <td>Sale</td>
                                    <td>
                                        <img src={check} alt="image" className='img-fluid' />
                                    </td>
                                    <td>5</td>
                                    <td>
                                        <span>2 Matic per kwh</span> <br />
                                        <small>(2.5 USD)</small>
                                    </td>
                                </tr>

                                <tr>
                                    <th scope="row">
                                        <div className='d-flex ai-center'>
                                            <img src={img_3} alt="image" className='img-fluid me-2' />
                                            Frost33
                                        </div>
                                    </th>
                                    <td><small className='failed'>Failed</small></td>
                                    <td>Purchase</td>
                                    <td>
                                        <img src={delet} alt="image" className='img-fluid' />
                                    </td>
                                    <td>5</td>
                                    <td>
                                        <span>2 Matic per kwh</span> <br />
                                        <small>(2.5 USD)</small>
                                    </td>
                                </tr>

                                <tr>
                                    <th scope="row">
                                        <div className='d-flex ai-center'>
                                            <img src={img_4} alt="image" className='img-fluid me-2' />
                                            Salium12
                                        </div>
                                    </th>
                                    <td><small className='success'>Success</small></td>
                                    <td>Sale</td>
                                    <td>
                                        <img src={check} alt="image" className='img-fluid' />
                                    </td>
                                    <td>5</td>
                                    <td>
                                        <span>2 Matic per kwh</span> <br />
                                        <small>(2.5 USD)</small>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Energy
